import { SHA256 } from "crypto-js";
import Hex from "crypto-js/enc-hex";
import { AuthenticationResultEnum } from "../../common/enums/AuthenticationResultEnum";
import { IeLynxUser } from "../../common/models/eLynxUser";
import LoginDataService from "../../services/login-data-service/LoginDataService";
import { IPasswordChangeModel } from "../../services/login-data-service/Models";
import UserDataService from "../../services/user-data-service/UserDataService";

const ChangePasswordFormUtils = {
    validateCurrentPassword: async function(user: IeLynxUser, currentPassword: string): Promise<AuthenticationResultEnum> {

        const hash: string = SHA256(currentPassword).toString(Hex);
        user.oldPasswordHash = hash;

        return UserDataService.validateCurrentPassword(user);
    },
    changePassword: async function(user: IeLynxUser, currentPassword: string, newPassword: string, confirmPassword: string) : Promise<IeLynxUser> {

        user.oldPasswordHash = SHA256(currentPassword).toString(Hex);
        user.passwordHash = SHA256(newPassword).toString(Hex);
        user.verifyPasswordHash = SHA256(confirmPassword).toString(Hex);

        return UserDataService.saveUserProfile(user as IeLynxUser);
    },
    updatePassword: async function(loginName: string,
        currentPassword: string | undefined,
        newPassword: string,
        confirmPassword: string,
        token: string,
        isNewUser: boolean) {


        const passwordChangeData: IPasswordChangeModel = {            
            loginName: loginName.trim(),
            currentPasswordHash: currentPassword ? SHA256(currentPassword).toString(Hex) : undefined,
            forgotPasswordToken: token,
            newPasswordHash: SHA256(newPassword).toString(Hex),
            newPasswordHashVerify: SHA256(confirmPassword).toString(Hex),
            newUser: isNewUser
        };

        return LoginDataService.updatePassword(passwordChangeData);
    }
};

export default ChangePasswordFormUtils;
